<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b] "> Option Modification</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Option Modification / Division / Office</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <h1 class="text-[#24723b] font-semibold text-lg">Search/Edit Admin Portal</h1>
            <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Division</button>
        </div>
        <div class="papsi-container h-[300px]overflow-auto mt-3">
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
            </div>
        </div>
    </div>

    <div v-if="AddDivision">
        <div @click="AddDivision = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#12760A] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-semibold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Create New Office/Division</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter New Office/Division" v-model="division">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Create Office/Division Abbreviation</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Office/Division Abbreviation" v-model="abbreviation">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#12760A] py-1.5 px-7 rounded-md text-center w-[100px]" v-if="Active === 'Add'" v-on:click="AddDivisionData">Add</button>
                <button class="text-sm text-white bg-[#12760A] py-1.5 px-7 rounded-md text-center w-[100px]" v-if="Active === 'Update'" v-on:click="EditDivisionData">Update</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md text-center w-[100px]" v-on:click="AddDivision = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    <div v-if="Validation">
        <Prompt type="VALIDATION" @close="Validation = false"/>
    </div>
    <div v-if="SuccessAddDivision">
        <Prompt type="ADDDIVISION" @close="SuccessAddDivision = false"/>
    </div>
    <div v-if="Update">
        <Prompt type="UPDATEOPTION" @close="Update = false"/>
    </div>
    
</template>

<script>
import Services from "../../services/admin"
import Prompt from "./Prompt/RequestPromt.vue"
import TableControl from "../controls/TableControl/TableControl.vue"
import { defineComponent } from "vue";

export default defineComponent({
    components:{
        TableControl,
        Prompt
    },
    data(){
        return{
            type:'',
            Update: false,
            SuccessAddDivision: false,
            Validation:    false,
            info:           null,
            division:         '',
            abbreviation:     '',
            AddDivision:   false,
            TableView:      true,
            result:           '',
            Active:        'Add',
            EditID:           '',
            hash:             '',
            AddedDivision:    '',
            header:[
                {
                    title:'Division No.'
                },
                {
                    title:'Division / Office'
                },
                {
                    title:'Abbreviation'
                },
                {
                    title:'Action'
                }
            ],
            column:[
                'division_code',
                'division_description',
                'Abbreviation'
            ],
        }
    },
     mounted(){
        this.getDivision()  
     }
    ,
    methods:{
        EditButton(row){
            this.type         =     'UPDATE DIVISION'
            this.Active       =     'Update'
            this.AddDivision  =     true
            this.EditId       =     row.id
            this.division     =     row.division_description
            this.abbreviation =     row.Abbreviation
        },

        async getDivision(){
            this.$emit("showLoader")
            this.hash = this.$cookies.get("hash")
            const success =  await Services.getDivision(this.hash)
            this.info     =  success.data
            this.$emit("hideLoader")
        },
        HideView(){
            this.type = 'ADD DIVISION'
            if (!this.TableView){
                this.TableView    =   true
                this.AddDivision  =  false
                
            }
            else{
                this.division     =     ''
                this.abbreviation =     ''
                this.AddDivision  =   true
                this.Active       =  'Add'
            }
        },
        async AddDivisionData(){
          
            this.$emit("showLoader")
            if(!this.division || !this.abbreviation){
                this.Validation  =  true
                this.$emit("hideLoader")
                return
            }

            const success = await Services.addDivision( this.division,this.abbreviation)
            this.result = success.success
            
            if(this.result === true){
                this.getDivision()

                this.AddDivision        =   false
                this.SuccessAddDivision =   true
            }
            this.$emit("hideLoader")
           
        },
        async EditDivisionData(){
            this.$emit("showLoader")
            const success = await Services.editDivision( this.division,this.abbreviation,this.EditId)
            this.result   = success.success
            if(this.result === true){
                this.getDivision()
                this.AddDivision = false
                this.$emit("hideLoader")
                this.Update = true
            }
            else{
                this.$emit("hideLoader")
            }
        }
    }
})

</script>




